"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Link;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ConfigProvider = require("../../providers/ConfigProvider");

var _DisabledLink = _interopRequireDefault(require("./DisabledLink"));

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Link(props, ref) {
  var _useConfig = (0, _ConfigProvider.useConfig)(),
      linkRenderer = _useConfig.linkRenderer;
  /* istanbul ignore next: iconPosition and size default values */


  var disabled = props.disabled,
      text = props.text,
      icon = props.icon,
      _props$iconPosition = props.iconPosition,
      iconPosition = _props$iconPosition === void 0 ? 'left' : _props$iconPosition,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      rest = _objectWithoutProperties(props, ["disabled", "text", "icon", "iconPosition", "size"]);

  var StyledLink = (0, _react.useMemo)(function () {
    return disabled ? _DisabledLink.default : (0, _styledComponents.default)(linkRenderer).withConfig({
      displayName: "Link",
      componentId: "j02y1q-0"
    })(["", ";"], _styles.linkStyles);
  }, [linkRenderer, disabled]);
  var LinkIcon = (0, _react.useMemo)(function () {
    if (!icon) {
      return null;
    }

    var Icon = icon;
    return _react.default.createElement(_styles.IconContainer, {
      "aria-hidden": true,
      position: iconPosition,
      withText: !!text
    }, _react.default.createElement(Icon, {
      size: size
    }));
  }, [icon, iconPosition, size, text]);
  return _react.default.createElement(StyledLink, _extends({}, rest, {
    ref: ref,
    size: size
  }), !!icon && iconPosition === 'left' && LinkIcon, text, !!icon && iconPosition === 'right' && LinkIcon);
}